<template>
    <div class="">
        <div class="">
            <h1 v-if="loadingData">
                <span class="loading-spinner"><font-awesome-icon icon="spinner" class="fa-spin 3x" /></span>
            </h1>

            <div v-if="currentVessel != '' && currentVessel != undefined">
                <!-- <h1>{{ currentVessel.vesselOwnerName }}</h1> -->

                <!-- {{ currentVessel.savedCompanyPassengerInductionItems }} -->

                <div v-if="expiryDatePast || isExpired || (isPrivate && !allowQrAccess)">
                    <div v-if="expiryDatePast || isExpired">
                        <div class="spacer s30"></div>
                        <div class="notification">
                            <span class="red">This vessel is not currently active on OffshoreSMS.</span>
                        </div>
                    </div>

                    <div v-else>
                        <div class="notification" v-if="isPrivate && !allowQrAccess">
                            <span class="black">Privacy mode is enabled for this vessel.</span>
                        </div>
                    </div>
                </div>

                <div v-else>
                    <div class="top-section">
                        <div class="top-inner">
                            <div class="top-avatar">
                                <div v-if="avatarUrl == ''" class="asset-initials">
                                    <span>{{ makeLetters() }}</span>
                                </div>
                                <div v-else :style="{ backgroundImage: `url(${avatarUrl})` }" class="asset-avatar" @click="viewImage(avatarUrl)">
                                    <!-- <img :src="avatarUrl" :alt="makeLetters()" /> -->
                                </div>
                            </div>
                            <div class="top-details">
                                <div class="top-title">{{ currentVessel.vesselName }}</div>
                                <div v-if="currentVessel.homePort && currentVessel.homePort != ''" class="top-subtitle">
                                    <span class="ts-icon"><font-awesome-icon icon="home" /></span>
                                    <span> {{ currentVessel.homePort ?? 'Unknown location' }}</span>
                                </div>
                                <div v-if="currentVessel.vesselOwnerName && currentVessel.vesselOwnerName != ''" class="top-subtitle">
                                    <span class="ts-icon"><font-awesome-icon icon="user-graduate" /></span>
                                    <span> {{ currentVessel.vesselOwnerName ?? 'Unknown owner' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="header-bar">
                        <div class="header-bar-inner">
                            <div
                                class="header-item tooltip"
                                v-for="tab in topTabs"
                                :key="tab.id"
                                :style="{ color: tab.color }"
                                :class="[{ 'is-active': currentTab == tab.slug }, { disabled: !visibleSections.includes(tab.slug) }]"
                                @click="currentTab = tab.slug">
                                <span class="tooltiptext tooltip-top">{{ tab.label }}</span>
                                <span class="tab-icon"><font-awesome-icon :icon="tab.icon" /></span>
                            </div>
                        </div>
                    </div>

                    <div class="tab-content">
                        <div class="tab-section" v-if="currentTab == 'story-timeline'">
                            <h5 :style="{ color: tabColors['story-timeline'] }">Story Timeline</h5>
                            <div v-if="visibleSections.includes('story-timeline')">
                                <div v-if="storyTimeline.length > 0">
                                    <div class="step-wrapper">
                                        <ul class="steps is-vertical">
                                            <li class="steps-segment is-orange" v-for="(entry, idx) in storyTimeline" :key="`entry-${idx}`">
                                                <span class="steps-marker is-orange"><font-awesome-icon icon="clock" /> </span>
                                                <div class="steps-content">
                                                    <p class="orange bold heading">{{ displayDate(entry.timestamp, true) }}</p>
                                                    <p class="title"><font-awesome-icon icon="pen" /> &nbsp;{{ entry.title }}</p>
                                                    <p class="heading"><font-awesome-icon icon="user" /> &nbsp;{{ entry.posterName }}</p>
                                                    <p v-if="entry.details && entry.details != ''" class="comment heading">
                                                        <font-awesome-icon icon="comment" /> &nbsp;{{ entry.details }}
                                                    </p>
                                                    <div class="timeline-img">
                                                        <img
                                                            v-for="(image, inx) in entry.photoUrls"
                                                            :key="`img-${inx}`"
                                                            :src="image"
                                                            class="thumbnail clickable"
                                                            @click="viewImage(image)" />
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-if="storyTimeline.length >= 20" class="has-text-grey-light mt-3">Showing the most recent 20 entries</div>
                                </div>
                                <div v-else>No timeline activities saved yet.</div>
                            </div>
                            <div v-else>
                                <p>This content has not been enabled by the asset owner.</p>
                            </div>
                        </div>

                        <div class="tab-section" v-if="currentTab == 'asset-info'">
                            <h5 :style="{ color: tabColors['asset-info'] }">Asset Information</h5>
                            <div v-if="visibleSections.includes('asset-info')">
                                <div v-if="assetProfileFields.length > 0">
                                    <div class="info-section box clean" v-for="item in assetProfileFields" :key="item.key">
                                        <div class="info-title">{{ formatFieldKey(item.key) }}</div>
                                        <div class="info-value" v-if="formatFieldValue(item.value)">
                                            <div v-for="(line, idx) in formatFieldValue(item.value).split('\n')" :key="`details-${idx}`">
                                                {{ line }}<br />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <p>No asset information found.</p>
                                </div>
                            </div>
                            <div v-else>
                                <p>This content has not been enabled by the asset owner.</p>
                            </div>
                        </div>

                        <div class="tab-section" v-if="currentTab == 'photo-gallery'">
                            <h5 :style="{ color: tabColors['photo-gallery'] }">Photo Gallery</h5>
                            <div v-if="visibleSections.includes('photo-gallery')">
                                <div v-if="galleryImages.length > 0">
                                    <div class="gallery-wrapper">
                                        <div class="image" v-for="(image, idx) in galleryImages" :key="`gallery-${idx}`">
                                            <img :src="image.imageUrl" alt="" @click="viewImage(image.imageUrl)" />
                                        </div>
                                    </div>
                                    <div v-if="galleryImages.length >= 20" class="has-text-grey-light mt-3">Showing the first 20 images</div>
                                </div>
                                <div v-else>No photos added to the gallery yet.</div>
                            </div>
                            <div v-else>
                                <p>This content has not been enabled by the asset owner.</p>
                            </div>
                        </div>

                        <div class="tab-section" v-if="currentTab == 'visitor-checkin'">
                            <h5 :style="{ color: tabColors['visitor-checkin'] }">Visitor Check-ins</h5>
                            <div v-if="visibleSections.includes('visitor-checkin')">
                                <p>
                                    If you are a visitor, contractor or other person on this marine asset, you can click the button below to complete
                                    the self check-in form.
                                </p>
                                <div class="spacer s30"></div>
                                <span
                                    class="button complex is-medium is-green"
                                    @click="openLink('https://go.offshoresms.com.au/visitor-check-in?vesselid=' + vesselID)">
                                    <div class="button-icon">
                                        <span><font-awesome-icon icon="users" /></span>
                                    </div>
                                    <div class="button-text">
                                        <div class="button-title">Visitor Check-in</div>
                                        <div class="button-subtitle">Click to start a new check-in form</div>
                                    </div>
                                </span>
                            </div>
                            <div v-else>
                                <p>This content has not been enabled by the asset owner.</p>
                            </div>
                        </div>

                        <div class="tab-section" v-if="currentTab == 'custom-logs'">
                            <h5 :style="{ color: tabColors['custom-logs'] }">Custom Forms</h5>
                            <p v-if="customLogs.length > 0">Select one of the available custom forms below.</p>
                            <div class="spacer s30"></div>
                            <div v-if="visibleSections.includes('custom-logs')">
                                <div v-if="customLogs.length > 0" class="logs-wrapper">
                                    <div
                                        v-for="(log, idx) in customLogs"
                                        :key="`custom-${idx}`"
                                        class="button complex is-medium is-skip"
                                        @click="toCustomLogBlank(log)">
                                        <div class="button-icon">
                                            <span><font-awesome-icon icon="pen" /></span>
                                        </div>
                                        <div class="button-text">
                                            <div class="button-title">{{ log.checklistName }}</div>
                                            <div class="button-subtitle">{{ truncate(log.logDescription, 150) }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="fleetCustomLogs.length > 0" class="logs-wrapper">
                                    <div
                                        v-for="(log, idx) in fleetCustomLogs"
                                        :key="`custom-${idx}`"
                                        class="button complex is-medium is-skip"
                                        @click="toCustomLogBlank(log)">
                                        <div class="button-icon">
                                            <span><font-awesome-icon icon="pen" /></span>
                                        </div>
                                        <div class="button-text">
                                            <div class="button-title">{{ log.checklistName }}</div>
                                            <div class="button-subtitle">{{ truncate(log.logDescription, 150) }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <p>This content has not been enabled by the asset owner.</p>
                            </div>
                        </div>

                        <div class="tab-section" v-if="currentTab == 'safety-info'">
                            <h5 :style="{ color: tabColors[selectedSafetySlug] }">
                                {{ selectedSafetyCategory }} &nbsp;
                                <span
                                    v-if="selectedSafetySlug != 'safety-info'"
                                    class="button is-light is-small"
                                    @click="
                                        selectedSafetySlug = 'safety-info';
                                        selectedSafetyCategory = 'Safety Information';
                                    ">
                                    <font-awesome-icon icon="times" /> &nbsp; View all
                                </span>
                            </h5>
                            <div v-if="visibleSections.includes('safety-info')">
                                <div v-if="selectedSafetySlug == 'safety-info'">
                                    <span
                                        v-for="sub in orderedSafetyButtons"
                                        :key="sub.slug"
                                        v-show="visibleSections.includes(sub.slug)"
                                        :class="['button', 'complex', 'is-medium', sub.colorClass]"
                                        @click="loadSafetyPage(sub.slug, sub.title)">
                                        <div class="button-icon">
                                            <span><font-awesome-icon :icon="sub.icon" /></span>
                                        </div>
                                        <div class="button-text">
                                            <div class="button-title">{{ sub.title }}</div>
                                            <div class="button-subtitle">{{ sub.subtitle }}</div>
                                        </div>
                                    </span>
                                </div>
                                <div v-else>
                                    <!-- all hazards / risk assessments: -->
                                    <div v-if="selectedSafetySlug == 'sms-hazards'" class="sms-other-content">
                                        <div v-if="loadedSections.includes('sms-hazards')">
                                            <div class="sms-item" v-for="item in allSafetyContent['sms-hazards']" :key="`sms-hazard-${item.id}`">
                                                <div class="item-title" :class="item.newRating">{{ item.title }}</div>
                                                <div class="sms-actions">
                                                    <span
                                                        class="button is-light is-small"
                                                        :class="item.newRating"
                                                        @click="viewHazardItem('Hazard', item)">
                                                        <font-awesome-icon icon="info-circle" /> &nbsp; View
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else><font-awesome-icon icon="spinner" class="fa-spin 3x" /> Loading hazards...</div>
                                    </div>

                                    <!-- all important contacts: -->
                                    <div v-if="selectedSafetySlug == 'sms-contacts'" class="sms-other-content">
                                        <div v-if="loadedSections.includes('sms-contacts')">
                                            <div class="sms-item" v-for="item in allSafetyContent['sms-contacts']" :key="`sms-contact-${item.id}`">
                                                <div class="item-title">{{ item.title }}</div>
                                                <div class="sms-actions">
                                                    <span
                                                        v-if="item.details && item.details != ''"
                                                        class="button is-light is-small"
                                                        @click="viewSmsItem('Contact', item)">
                                                        <font-awesome-icon icon="info-circle" /> &nbsp; View
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else><font-awesome-icon icon="spinner" class="fa-spin 3x" /> Loading contacts...</div>
                                    </div>

                                    <!-- all policies: -->
                                    <div v-if="selectedSafetySlug == 'sms-policies'" class="sms-other-content">
                                        <div v-if="loadedSections.includes('sms-policies')">
                                            <div class="sms-item" v-for="item in allSafetyContent['sms-policies']" :key="`sms-policy-${item.id}`">
                                                <div class="item-title">{{ item.title }}</div>
                                                <div class="sms-actions">
                                                    <span
                                                        v-if="item.details && item.details != ''"
                                                        class="button is-light is-small"
                                                        @click="viewSmsItem('Policy', item)">
                                                        <font-awesome-icon icon="info-circle" /> &nbsp; View
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else><font-awesome-icon icon="spinner" class="fa-spin 3x" /> Loading policies...</div>
                                    </div>

                                    <!-- all emergency procedures: -->
                                    <div v-if="selectedSafetySlug == 'sms-eops'" class="sms-other-content">
                                        <div v-if="loadedSections.includes('sms-eops')">
                                            <div class="sms-item" v-for="item in allSafetyContent['sms-eops']" :key="`sms-contact-${item.id}`">
                                                <div class="item-title">{{ item.title }}</div>
                                                <div class="sms-actions">
                                                    <span
                                                        v-if="item.details && item.details != ''"
                                                        class="button is-light is-small"
                                                        @click="viewSmsItem('Emergency Procedure', item)">
                                                        <font-awesome-icon icon="info-circle" /> &nbsp; View
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else><font-awesome-icon icon="spinner" class="fa-spin 3x" /> Loading emergency procedures...</div>
                                    </div>

                                    <!-- all safe work procedures: -->
                                    <div v-if="selectedSafetySlug == 'sms-sops'" class="sms-other-content">
                                        <div v-if="loadedSections.includes('sms-sops')">
                                            <div class="sms-item" v-for="item in allSafetyContent['sms-sops']" :key="`sms-contact-${item.id}`">
                                                <div class="item-title">{{ item.title }}</div>
                                                <div class="sms-actions">
                                                    <span
                                                        v-if="item.details && item.details != ''"
                                                        class="button is-light is-small"
                                                        @click="viewSmsItem('Safe Work Procedure', item)">
                                                        <font-awesome-icon icon="info-circle" /> &nbsp; View
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else><font-awesome-icon icon="spinner" class="fa-spin 3x" /> Loading safe work procedures...</div>
                                    </div>

                                    <!-- all safety briefing items: -->
                                    <div v-if="selectedSafetySlug == 'sms-briefings'" class="sms-other-content">
                                        <div v-if="loadedSections.includes('sms-briefings')">
                                            <div class="sms-item" v-for="item in allSafetyContent['sms-briefings']" :key="`sms-contact-${item.id}`">
                                                <div class="item-title">{{ item.title }}</div>
                                                <div class="sms-actions">
                                                    <span
                                                        v-if="item.details && item.details != ''"
                                                        class="button is-light is-small"
                                                        @click="viewSmsItem('Safety Briefing Item', item)">
                                                        <font-awesome-icon icon="info-circle" /> &nbsp; View
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else><font-awesome-icon icon="spinner" class="fa-spin 3x" /> Loading safety briefing items...</div>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <p>This content has not been enabled by the asset owner.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="spacer s30"></div>

                <hr v-if="!expiryDatePast && !isExpired && !isPrivate" />

                <div class="spacer s10"></div>
                <div v-if="!expiryDatePast && !isExpired && !isPrivate" class="buttons centered">
                    <span @click="showActivateModal = true" class="button is-light is-small">
                        <font-awesome-icon icon="lock" /> &nbsp; Is this your vessel?
                    </span>
                    <span class="button is-light is-small" @click="showInfoModal = true">
                        <font-awesome-icon icon="info-circle" /> &nbsp; More Info
                    </span>
                </div>
            </div>

            <div v-else><span v-if="!loadingData">Loading vessel information..</span></div>

            <!-- <div class="buttons centered">
                <span @click="goBack()" class="button is-warning"><font-awesome-icon icon="chevron-left" /> &nbsp; Back</span>
            </div> -->

            <div class="spacer s100"></div>
            <div class="spacer s100"></div>

            <details-modal title="Is this your vessel?" :fullscreen="fullscreen" theme="blue" @closed="close()" v-if="showActivateModal">
                <div class="centered">
                    <h5>
                        If you'd like to activate your free <span class="green">digital vessel profile</span>, simply download the app from your App
                        Store and create a free user profile, then give us a call on the number below.
                    </h5>
                    <div class="spacer s20"></div>
                    <div class="download">
                        <a href="https://apps.apple.com/us/app/offshoresms/id1526656158" target="_blank" rel="noreferrer">
                            <img :src="require(`../assets/app-store.png`)" alt="OffshoreSMS app on the Apple App Store" />
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=offshoresms.appdev.nybble.com.smsapp" target="_blank" rel="noreferrer">
                            <img :src="require(`../assets/play-store.png`)" alt="OffshoreSMS app on the Google Play Store" />
                        </a>
                    </div>
                    <div class="spacer s20"></div>
                    <div><a class="button is-primary" href="tel:+61-447-139-382">Call +61 447 139 382</a></div>
                    <div class="spacer s20"></div>
                </div>
            </details-modal>

            <simple-modal title="View Image" theme="is-primary" :fullWidth="true" @closed="close()" v-if="showImageModal">
                <div class="view-image-wrapper">
                    <img :src="selectedImage" alt="" />
                </div>
            </simple-modal>

            <details-modal :title="selectedItem.title" theme="blue" @closed="close()" v-if="showSmsModal">
                <div v-for="(line, index) in selectedItem.details.split('\n')" :key="index">{{ line }}<br /></div>
                <div class="spacer s20"></div>
                <div v-if="selectedItem.link != ''" class="link">
                    <a :href="selectedItem.link" target="_blank" class="simple-link">Link:&nbsp;{{ selectedItem.link }}</a>
                </div>

                <div v-if="selectedItem.uploadUrls.length > 0">
                    <div class="spacer s30"></div>
                    <label class="label">PHOTOS:</label>
                    <div v-for="(image, idx) in selectedItem.uploadUrls" :key="`images-${idx}`" class="image-wrap2" @click="zoomIn(idx)">
                        <img :src="image" />
                    </div>
                </div>

                <div v-if="selectedItem.uploadPDFs.length > 0" class="image-div">
                    <div class="spacer s30"></div>
                    <div class="clear"></div>
                    <label class="label">ATTACHED PDFs:</label>
                    <ul class="uploads">
                        <li @click="zoomInPDF(idx)" class="image-wrap" v-for="(image, idx) in selectedItem.uploadPDFs" :key="`pdf-${idx}`">
                            <img src="@/assets/img/pdf-image-placeholder.png" />
                        </li>
                        <div class="clear"></div>
                    </ul>
                </div>

                <hr />
                <h4 class="heading" v-if="selectedItem.versioned">Last Edit: {{ displayDate(selectedItem.versionDate, false) }}</h4>
            </details-modal>

            <details-modal :title="selectedItem.title" :theme="selectedItem.rating" @closed="close()" v-if="showHazardModal">
                <div class="spacer s10"></div>
                <table class="table is-bordered is-hoverable is-fullwidth">
                    <tbody>
                        <tr>
                            <th>Hazard</th>
                            <td class="caps red">{{ selectedItem.title }}</td>
                        </tr>
                        <tr>
                            <th>Posted on</th>
                            <td>{{ displayDate(selectedItem.versionDate, false) }}</td>
                        </tr>
                        <tr>
                            <th>Risk Pairs</th>

                            <td>
                                <div v-if="selectedItem.riskPairs && selectedItem.riskPairs.length > 0">
                                    <div v-for="(item, idx) in selectedItem.riskPairs" class="risk-pair" :key="`risk-pair-${idx}`">
                                        <div class="risk-pair-item risk">
                                            <div class="risk-pair-title">Risk</div>
                                            <div class="risk-pair-details">
                                                <div v-for="(line, idx) in item.risk.split('\n')" :key="`risk-${idx}`">{{ line }}<br /></div>
                                            </div>
                                        </div>
                                        <div class="risk-pair-item control">
                                            <div class="risk-pair-title control">Control</div>
                                            <div class="risk-pair-details">
                                                <div v-for="(line, idx) in item.control.split('\n')" :key="`line-control-${idx}`">
                                                    {{ line }}<br />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="selectedItem.risks && selectedItem.risks != ''">
                            <th>Legacy Risks*</th>
                            <td>
                                <div v-for="(line, idx) in selectedItem.risks.split('\n')" :key="`risks-${idx}`">
                                    {{ line }}
                                    <br />
                                </div>
                            </td>
                        </tr>
                        <tr v-if="selectedItem.controls && selectedItem.controls != ''">
                            <th>Legacy Controls*</th>
                            <td>
                                <div v-for="(line, idx) in selectedItem.controls.split('\n')" :key="`controls-${idx}`">
                                    {{ line }}
                                    <br />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>RISK RATING (after controls in place)</th>
                            <td>
                                <span :class="selectedItem.rating" class="rating caps">{{ selectedItem.rating }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th>Who's responsible?</th>
                            <td>{{ responsibleList(selectedItem.personResponsible) }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="spacer s10"></div>
                <hr />

                <div v-if="selectedItem.uploadUrls.length > 0">
                    <div class="spacer s30"></div>
                    <label class="label">PHOTOS:</label>
                    <div v-for="(image, idx) in selectedItem.uploadUrls" :key="`images-${idx}`" class="image-wrap2" @click="zoomIn(idx)">
                        <img :src="image" />
                    </div>
                </div>

                <div v-if="selectedItem.uploadPDFs.length > 0" class="image-div">
                    <div class="spacer s30"></div>
                    <div class="clear"></div>
                    <label class="label">ATTACHED PDFs:</label>
                    <ul class="uploads">
                        <li @click="zoomInPDF(idx)" class="image-wrap" v-for="(image, idx) in selectedItem.uploadPDFs" :key="`pdf-${idx}`">
                            <img src="@/assets/img/pdf-image-placeholder.png" />
                        </li>
                        <div class="clear"></div>
                    </ul>
                </div>

                <h4 class="heading" v-if="selectedItem.versioned">Last Edit: {{ displayDate(selectedItem.versionDate, false) }}</h4>
            </details-modal>

            <simple-modal title="More Information" theme="is-primary" @closed="close()" v-if="showInfoModal">
                <div class="">
                    <p class="blue bold">
                        The OffshoreSMS marine asset profile page is the best way to view information, history timelines, photo galleries and even
                        important safety information for any commercial vessel.
                    </p>
                    <p class="orange bold">
                        If you have a commercial vessel or other marine asset, and you don't have a vessel profile on OffshoreSMS yet, download the
                        app and add your vessel today!
                    </p>
                    <h1 class="green bold">It's 100% free to get started.</h1>
                </div>
            </simple-modal>

            <!-- Viewing pictures -->
            <SimpleModal v-if="showZoomInImage" @closed="zoomOut" title="View Image" cancelText="Close" showCancel>
                <div class="is-flex is-justify-content-center"><img :src="selectedItem.uploadUrls[shownImageIndex]" /></div>
            </SimpleModal>

            <!-- Viewing PDFs -->
            <SimpleModal v-if="showZoomInPDF" @closed="zoomOut" :fullWidth="true" title="View PDF" cancelText="Close" showCancel>
                <div class="is-flex is-justify-content-center">
                    <div style="height: 100%; width: 100%; height: 80vh">
                        <iframe width="100%" height="100%" :src="selectedItem.uploadPDFs[shownPDFIndex].imageUrl" frameborder="0"></iframe>
                    </div>
                </div>
            </SimpleModal>
        </div>
    </div>
</template>

<script>
const DetailsModal = () => import('../reusables/DetailsModal.vue');
const SimpleModal = () => import('../reusables/SimpleModal.vue');
import { getFunctions, httpsCallable } from 'firebase/functions';
import NProgress from 'nprogress';

const functions = getFunctions();
const aus_functions = getFunctions(undefined, 'australia-southeast1');
const addRevision = httpsCallable(functions, 'addRevision');
const loadPublicVesselInfo = httpsCallable(aus_functions, 'asset_functions-loadPublicVesselInfo');

export default {
    props: {
        sentVessel: Object
    },

    mounted() {
        NProgress.done();
        this.vesselID = this.$route.query.vesselid ? this.$route.query.vesselid : this.sentVessel ? this.sentVessel.vesselID : '';
        this.screenID = this.$route.query.screenid ? this.$route.query.screenid : 'vessel';
        this.docID = this.$route.query.docid ? this.$route.query.docid : '';
        this.loadAllData();
    },

    components: {
        DetailsModal,
        SimpleModal
    },

    computed: {
        currentVessel() {
            return this.$store.getters.getCurrentVessel;
        },
        avatarUrl() {
            return this.currentVessel.avatarUrl ?? '';
        },
        expiryDatePast() {
            if (
                !this.currentVessel ||
                this.currentVessel.nextChargeDate == undefined ||
                typeof this.currentVessel.nextChargeDate === 'string' ||
                typeof this.currentVessel.nextChargeDate === 'number'
            )
                return false;
            let ncd;
            if (this.currentVessel.nextChargeDate.toDate) {
                ncd = this.currentVessel.nextChargeDate.toDate();
            } else if (this.currentVessel.nextChargeDate._seconds != undefined) {
                ncd = new Date(this.currentVessel.nextChargeDate._seconds * 1000);
            } else if (this.currentVessel.nextChargeDate.seconds != undefined) {
                ncd = new Date(this.currentVessel.nextChargeDate.seconds * 1000);
            } else {
                return false;
            }
            let now = new Date();
            return ncd.getTime() < now.getTime();
        },
        isExpired() {
            return !this.currentVessel ? false : this.currentVessel.isExpired ? this.currentVessel.isExpired : false;
        },
        isPrivate() {
            return !this.currentVessel ? false : this.currentVessel.isPrivate ? this.currentVessel.isPrivate : false;
        },
        allowQrAccess() {
            return !this.currentVessel ? false : this.currentVessel.allowQrAccess ? this.currentVessel.allowQrAccess : false;
        },
        isTeamVessel() {
            return !this.currentVessel ? false : this.currentVessel.vesselOwnerID == 'rWlzr3viZohnyspfellhe5XPQ4J3';
        },
        vesselIsPro() {
            return this.currentVessel.aaaPlans.includes('pro');
        },
        savedFleetCustomLogs() {
            return this.currentVessel.savedFleetCustomLogs ?? [];
        },
        visibleSections() {
            if (this.publicSections.length > 0) {
                return this.publicSections.filter((s) => s.enabled).map((s) => s.slug);
            }
            return this.currentVessel.savedPublicSections ?? ['story-timeline', 'asset-info', 'photo-gallery'];
        }
    },

    data() {
        return {
            vesselID: '',
            screenID: '',
            docID: '',
            loadingData: false,
            vesselName: '',
            showActivateModal: false,
            fullscreen: true,

            defaultTopTabs: [
                { slug: 'story-timeline', color: 'dodgerblue', icon: 'comments', label: 'Story Timeline' },
                { slug: 'asset-info', color: 'orange', icon: 'info-circle', label: 'Asset Info' },
                { slug: 'photo-gallery', color: 'mediumseagreen', icon: 'images', label: 'Photo Gallery' },
                { slug: 'visitor-checkin', color: 'purple', icon: 'file-signature', label: 'Visitor Check-in' },
                { slug: 'custom-logs', color: 'hotpink', icon: 'clipboard-list', label: 'Custom Forms' },
                { slug: 'safety-info', color: 'red', icon: 'life-ring', label: 'Safety Information' }
            ],
            topTabs: [],
            defaultSafetyButtons: [
                {
                    slug: 'sms-hazards',
                    icon: 'exclamation-triangle',
                    colorClass: 'is-orange',
                    title: 'Vessel Hazards',
                    subtitle: 'All hazards on this vessel'
                },
                {
                    slug: 'sms-contacts',
                    icon: 'users',
                    colorClass: 'is-green',
                    title: 'Emergency Contacts',
                    subtitle: 'Important contacts on this vessel'
                },
                { slug: 'sms-policies', icon: 'users', colorClass: 'is-grey', title: 'All Policies', subtitle: 'All policies on this vessel' },
                { slug: 'sms-eops', icon: 'ship', colorClass: '', title: 'Emergency Procedures', subtitle: 'Know what to do and when' },
                {
                    slug: 'sms-sops',
                    icon: 'list-ul',
                    colorClass: 'is-purple',
                    title: 'Safe Work Procedures',
                    subtitle: 'How to do everything on this asset'
                },
                {
                    slug: 'sms-briefings',
                    icon: 'info',
                    colorClass: 'is-red',
                    title: 'General Safety Briefing',
                    subtitle: 'A safety checklist for this vessel'
                }
            ],
            orderedSafetyButtons: [],
            tabColors: {
                'story-timeline': 'dodgerblue',
                'asset-info': 'orange',
                'photo-gallery': 'mediumseagreen',
                'visitor-checkin': 'purple',
                'custom-logs': 'hotpink',
                'safety-info': 'red',
                'sms-hazards': 'orange',
                'sms-eops': 'dodgerblue',
                'sms-sops': '#bd0ebd',
                'sms-contacts': 'mediumseagreen',
                'sms-policies': '#636963',
                'sms-briefings': '#eb1f1f'
            },
            currentTab: '',
            showImageModal: false,
            selectedImage: '',
            assetProfileFields: [],
            storyTimeline: [],
            galleryImages: [],
            customLogs: [],
            fleetCustomLogs: [],
            selectedSafetyCategory: 'Safety Information',
            selectedSafetySlug: 'safety-info',
            loadedSections: [],
            allSafetyContent: {
                'sms-hazards': [],
                'sms-eops': [],
                'sms-sops': [],
                'sms-contacts': [],
                'sms-policies': [],
                'sms-briefings': []
            },
            publicSections: [],
            selectedItem: {},
            showSmsModal: false,
            showHazardModal: false,
            showInfoModal: false,

            shownImageIndex: 10,
            showZoomInImage: false,
            shownPDFIndex: 10,
            showZoomInPDF: false
        };
    },

    methods: {
        toPage(page) {
            this.$router.push({
                name: page,
                params: {}
            });
        },

        openLink(url) {
            window.open(url, '_blank');
        },

        close() {
            this.showActivateModal = false;
            this.showInfoModal = false;
            this.selectedImage = '';
            this.showImageModal = false;
            this.selectedItem = {};
            this.showSmsModal = false;
            this.showHazardModal = false;
            this.showInfoModal = false;
            this.showZoomInImage = false;
            this.showZoomInPDF = false;
        },

        toCustomLogBlank(log) {
            let webLink = log.webLink ? log.webLink : '';
            let url = 'https://go.offshoresms.com.au/vessel-logs?x=' + webLink + '&a=' + this.vesselID;
            window.open(url, '_blank');
        },

        viewHazardItem(title, item) {
            this.selectedItem = item;
            // if (item.risks != '') {
            this.showHazardModal = true;
            // }
        },

        viewSmsItem(title, item) {
            this.selectedItem = item;
            if (item.details != '') {
                this.showSmsModal = true;
            }
        },

        toCustomLog(log) {
            // console.log(log);
            let currentCustomLog = log.id;
            let webLink = log.webLink ? log.webLink : '';
            this.$store.dispatch('SETCURRENTCUSTOMLOG', { currentCustomLog });
            let self = this;
            this.$router.push({
                name: 'VesselLogs',
                params: {
                    hasLog: webLink != '',
                    webLink: webLink,
                    sentCustomLog: log
                }
            });
        },

        goBack() {
            this.$router.go(-1);
        },

        truncate(string, limit) {
            // console.log(string,limit);
            if (string == undefined || string == '') return '';
            return string.length > limit ? string.slice(0, limit) + '...' : string;
        },

        displayDate(sentDate, full) {
            if (typeof sentDate == 'string' || typeof sentDate == 'number') return sentDate;
            const dateOptions = full
                ? { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' }
                : { month: 'short', day: 'numeric', year: 'numeric' };
            if (!sentDate) {
                return 'No date';
            }
            if (sentDate.toDate) {
                return sentDate.toDate().toLocaleDateString('en-US', dateOptions);
            }
            const seconds = sentDate._seconds ?? sentDate.seconds ?? 0;
            const nanoseconds = sentDate._nanoseconds ?? sentDate.nanoseconds ?? 0;
            let t = new Date(seconds * 1000 + nanoseconds / 1000000);
            return t.toLocaleDateString('en-US', dateOptions);
        },

        responsibleList(array) {
            var tempList = array ? array.join(', ') : '';
            return tempList;
        },

        makeLetters() {
            const displayName = this.currentVessel.vesselName ?? '? ?';
            let res = displayName.split(' ');
            if (res.length > 1) {
                return res[0].substring(0, 1) + res[1].substring(0, 1);
            } else {
                return res[0].substring(0, 1);
            }
        },

        zoomInPDF(index) {
            this.showZoomInPDF = true;
            this.shownPDFIndex = index;
        },

        zoomIn(index) {
            // Bejai note: originally I had commented lines to avoid modals stacking, but now I'm thinking it's okay since helps remember where you were
            this.showZoomInImage = true;
            this.shownImageIndex = index;
        },

        zoomOut() {
            this.showZoomInImage = false;
            this.showZoomInPDF = false;
        },

        viewImage(url) {
            this.selectedImage = url;
            this.showImageModal = true;
        },

        async loadAllData() {
            if (this.vesselID == '') return;
            this.loadingData = true;

            try {
                const result = await loadPublicVesselInfo({ vesselID: this.vesselID });
                if (!result.data.success) {
                    this.loadingData = false;
                    return;
                }

                const data = result.data;

                // Set vessel data in store
                let allData = data.vesselData;
                allData.vesselID = this.vesselID;
                allData.savedAppInfoSections = allData.savedAppInfoSections ?? [];
                allData.savedPublicSections = allData.savedPublicSections ?? ['story-timeline', 'asset-info', 'photo-gallery'];
                this.$store.dispatch('UPDATESELECTEDVESSEL', { allData });

                // Log revision
                addRevision({
                    userID: '',
                    userName: '',
                    description: 'QR code information page on OffshoreSMS Go successfully loaded for the vessel ' + allData.vesselName
                });

                this.assetProfileFields = data.assetProfileFields ?? [];
                this.storyTimeline = data.storyTimeline ?? [];
                this.galleryImages = data.galleryImages ?? [];
                this.customLogs = data.customLogs ?? [];
                this.fleetCustomLogs = data.fleetCustomLogs ?? [];

                // Populate safety content (all pre-loaded)
                if (data.safetyContent) {
                    this.allSafetyContent = data.safetyContent;
                    this.loadedSections = Object.keys(data.safetyContent);
                }

                // Process public sections (migrated subcollection vs legacy flat array)
                this.publicSections = data.publicSections ?? [];
                this.applyPublicSectionsOrder();

                // Set initial tab
                this.currentTab = this.visibleSections
                    ? this.visibleSections.includes('story-timeline')
                        ? 'story-timeline'
                        : this.visibleSections[0]
                    : 'story-timeline';
            } catch (error) {
                // CF call failed
            }

            this.loadingData = false;
        },

        formatFieldKey(key) {
            return key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (c) => c.toUpperCase());
        },

        formatFieldValue(value) {
            if (value === null || value === undefined) return '';
            if (typeof value === 'boolean') return value ? 'Yes' : 'No';
            if (typeof value === 'string' || typeof value === 'number') return String(value);
            if (Array.isArray(value)) {
                if (value.length === 0) return '';
                if (typeof value[0] === 'string') return value.join('\n');
                if (typeof value[0] === 'object') {
                    return value
                        .map((obj) => {
                            return Object.entries(obj)
                                .filter(([, v]) => v !== null && v !== undefined && v !== '')
                                .map(([k, v]) => `${k.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (c) => c.toUpperCase())}: ${v}`)
                                .join('\n');
                        })
                        .join('\n\n');
                }
            }
            return String(value);
        },

        applyPublicSectionsOrder() {
            const tabLookup = {};
            this.defaultTopTabs.forEach((t) => {
                tabLookup[t.slug] = t;
            });

            const safetyLookup = {};
            this.defaultSafetyButtons.forEach((s) => {
                safetyLookup[s.slug] = s;
            });

            if (this.publicSections.length > 0) {
                const topSections = this.publicSections.filter((s) => !s.parent).sort((a, b) => a.order - b.order);
                const safetySections = this.publicSections.filter((s) => s.parent === 'safety-info').sort((a, b) => a.order - b.order);

                this.topTabs = topSections.map((s) => tabLookup[s.slug]).filter(Boolean);
                this.orderedSafetyButtons = safetySections.map((s) => safetyLookup[s.slug]).filter(Boolean);
            } else {
                this.topTabs = [...this.defaultTopTabs];
                this.orderedSafetyButtons = [...this.defaultSafetyButtons];
            }
        },

        loadSafetyPage(slug, heading) {
            this.selectedSafetySlug = slug;
            this.selectedSafetyCategory = heading;
        }
    }
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 1rem;
}

.notification {
    font-size: 1.15rem;
    max-width: 90%;
    margin: 0 auto 1rem;

    span {
        &.black {
            color: black;
        }

        &.green {
            color: green;
        }
    }
}

h5 {
    font-size: 1.2rem;
    max-width: 600px;
    margin: 1rem auto 0.6rem;
    font-weight: bold;
}
iframe {
    width: 100%;
    height: 100%;
    min-height: 500px;
}

.download {
    a {
        display: inline-block;
        max-width: 150px;
        margin: 0 4px;
    }
}

.top-section {
    width: 100%;
    margin: 30px 0;
    .top-inner {
        margin: 0 auto;
        max-width: 700px;
        display: flex;
        padding: 0 30px;
        .top-avatar {
            width: 90px;
            margin-right: 10px;
            .asset-initials {
                width: 90px;
                height: 90px;
                border-radius: 50%;
                text-align: center;
                position: relative;
                background: steelblue;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: 0.3s;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center center;
                span {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 28px;
                    color: #fff;
                    font-weight: bold;
                    text-transform: uppercase;
                }
            }
            .asset-avatar {
                width: 90px;
                height: 90px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                background-size: cover;
                background-position: center center;
                img {
                    max-width: 100%;
                }
            }
        }
        .top-details {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            .top-title {
                color: steelblue;
                font-weight: bold;
                font-size: 1.3rem;
                text-align: left;
                line-height: 1.4rem;
            }
            .top-subtitle {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                text-align: left;
                .ts-icon {
                    // font-size: 1.2rem;
                    margin-right: 8px;
                }
            }
            .buttons {
                margin-top: 8px;
                .button {
                }
            }
        }
    }
}
.header-bar {
    background: #f8f8f8;
    width: 100%;
    position: sticky;
    top: 55px;
    z-index: 40;
    .header-bar-inner {
        max-width: 700px;
        margin: 0 auto 1.5rem;
        display: flex;
        justify-content: center;
        padding: 0 1rem;
        flex-wrap: wrap;
        .header-item {
            cursor: pointer;
            height: 100%;
            padding: 8px 30px;
            transition: 0.25s;
            .tab-icon {
                font-size: 1.8rem;
                color: inherit;
                transition: 0.25s;
                display: block;
            }
            &:hover {
                .tab-icon {
                    transform: scale(1.2);
                }
            }
            &.is-active {
                background: dodgerblue;
                .tab-icon {
                    color: white;
                }
            }
            &.disabled {
                display: none;
            }
        }
    }
}
.tooltip .tooltiptext.tooltip-top {
    bottom: 65px;
    padding: 10px;
    width: auto;
    min-width: 120px;
    line-height: 1rem;
}

.tab-content {
    margin: 0 auto 5rem;
    padding: 0 20px;
    max-width: 700px;
    .tab-section {
        .info-section {
            text-align: left;
            // border-bottom: 1px solid #f8f8f8;
            padding-bottom: 1rem;
            margin-bottom: 1rem;
            .info-title {
            }
            .info-value {
                padding-left: 6px;
                font-weight: bold;
                color: dodgerblue;
            }
            &:last-of-type {
                border-bottom: none;
            }
        }
        .step-wrapper {
            text-align: left;
            .steps-content {
                padding-bottom: 3rem;
                .title {
                    font-size: 1.1rem;
                    color: dodgerblue;
                    margin-bottom: 7px;
                }
                .comment {
                    margin-bottom: 15px;
                }
                .timeline-img {
                    max-width: 200px;
                    img {
                        display: block;
                        border-radius: 10px;
                    }
                }
            }
        }
        .gallery-wrapper {
            display: flex;
            flex-wrap: wrap;
            .image {
                width: 100%;
                max-width: 170px;
                margin: 0 10px 20px;
                border: 1px solid #e8e8e8;
                border-radius: 5px;
                overflow: hidden;
                img {
                    width: 100%;
                    border-radius: 10px;
                    cursor: pointer;
                    transition: 0.3s;
                    &:hover {
                        transform: scale(1.05);
                    }
                }
            }
        }
    }
}

.sms-other-content {
    margin-top: 2.5rem;
    .sms-item {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding-bottom: 18px;
        margin-bottom: 16px;
        border-bottom: 1px solid #f1f1f1;
        .item-title {
            flex-grow: 1;
            text-align: left;
        }
        .item-details {
        }
        .sms-actions {
            width: 90px;
            text-align: right;
            .button {
                &.low {
                    background-color: #67bf8e;
                    color: #fff;
                }
                &.medium {
                    background-color: #ffbb3e;
                    color: #fff;
                }
                &.high {
                    background-color: #ff7600;
                    color: #fff;
                }
                &.extreme {
                    background-color: #ee4646;
                    color: #fff;
                }
            }
        }
        &:last-of-type {
            border-bottom: none;
        }
    }
}

.hazard-item {
    margin-bottom: 1.5rem;

    .hazard-title {
        font-size: 0.8rem;
        text-transform: uppercase;
        color: #666;
        margin-bottom: 5px;
    }

    .hazard-details {
        padding-left: 6px;

        &.low {
            color: green;
        }

        &.medium {
            color: orange;
        }

        &.high {
            color: red;
        }
    }
}

@media only screen and (max-width: 759px) {
    .tooltip .tooltiptext.tooltip-top {
        display: none;
    }
    .header-bar {
        .header-bar-inner {
            .header-item {
                padding: 5px 18px;
                .tab-icon {
                    font-size: 1.3rem;
                }
            }
        }
    }
}

@media only screen and (max-width: 479px) {
    .download {
        a {
            max-width: 130px;
        }
    }
}
</style>
